var SHTHelper = window.SHTHelper || {};
SHTHelper.theme = {};

(function($) {

  var PRODUCT_IMG_THRESHOLD = 23;
  var PRODUCT_IMAGES = $('#product__images').length ? JSON.parse($('#product__images').html()) : null;
  if (PRODUCT_IMAGES) {
    // PRODUCT_IMAGES = PRODUCT_IMAGES.filter(function(item) {
    //   return item.url.includes('tiny-tray--') || item.url.indexOf('__') === -1;
    // });
  }
  console.log(PRODUCT_IMAGES)
  var _appendToFilename = function(filename, str) {
    var dot_indx = filename.lastIndexOf('.');

    if (dot_indx === -1) {
      return filename + str;
    } else {
      return filename.substring(0, dot_indx) + str + filename.substring(dot_indx);
    }
  };

  var setActiveThumbnail = function(target) {
    var THUMB_ACTIVE_CLASS = 'gallery__thumbnail-wrapper--active';

    if (!target.hasClass(THUMB_ACTIVE_CLASS) && target.hasClass('gallery__thumbnail-wrapper')) {
      target.addClass(THUMB_ACTIVE_CLASS).siblings().removeClass(THUMB_ACTIVE_CLASS);
    }
  };

  var setActivePagination = function(target) {
    var PAGINATION_ACTIVE_CLASS = 'gallery__pagination-item--active';

    if (!target.hasClass(PAGINATION_ACTIVE_CLASS) && target.hasClass('gallery__pagination-item')) {
      target.addClass(PAGINATION_ACTIVE_CLASS).siblings().removeClass(PAGINATION_ACTIVE_CLASS);
    }
  };

  SHTHelper._buildProductPhotoGallery = function(specific_sku, include_thumbnails) {

    var imgs_html = '',
      thumb_html = '',
      pagingation_html = '',
      gallery_height,
      preloaded_img,
      product_imgs = PRODUCT_IMAGES;

    if (specific_sku) {
      console.log(specific_sku)
      console.log("specific_sku")
      product_imgs = product_imgs.filter(function(img) {
        return img.url.includes('_' + specific_sku + '_') || img.url.includes('_0' + specific_sku + '_') || img.url.includes('info') || img.url.includes('lifestyle');
      });
    }


    product_imgs.map(function(img, indx) {
      var img_2048 = _appendToFilename(img.url, '_2048x'),
        img_500 = _appendToFilename(img.url, '_500x'),
        img_929 = _appendToFilename(img.url, '_929x'),
        img_680 = _appendToFilename(img.url, '_680x'),
        img_600 = _appendToFilename(img.url, '_600x'),
        img_700 = _appendToFilename(img.url, '_735x'),
        img_800 = _appendToFilename(img.url, '_831x'),
        img_1600 = _appendToFilename(img.url, '_1600x');

      imgs_html += '<figure data-reswiper-slide-index="' + indx + '" class="reswiper-slide"><a href="' + img_2048 + '" data-size="' + img.ratio + '"><img alt="' + img.alt + '" loading="eager" sizes="auto" width="' + img.width + '"  height="' + img.height + '" src="' + img_929 + '" srcset="' + img_500 + ' 480w,' + img_600 + ' 600w,' + img_680 + ' 680w,' + img_700 + ' 768w,' + img_500 + ' 1024w,' + img_600 + ' 1200w,' + img_680 + ' 1366w,' + img_700 + ' 1440w,' + img_800 + ' 1600w,' + img_929 + ' 1920w, ' + img_1600 + ' 2000w"></a></figure>'
    });

    var img_file_120;

    if (include_thumbnails) {
      product_imgs.map(function(img, indx) {
        img_file_120 = $('<img/>');
        img_file_120.src = _appendToFilename(img.url, '_120x');
        img_file_60 = $('<img/>');
        img_file_60.src = _appendToFilename(img.url, '_60x');

        var img_60 = _appendToFilename(img.url, '_60x'),
          img_120 = _appendToFilename(img.url, '_120x');

        thumb_html += '<a href="#" role="presentation" class="gallery__thumbnail-wrapper" data-image-index="' + indx + '"><img class="gallery__thumbnail" alt="' + img.alt + '" src="' + img_120 + '" srcset="' + img_120 + ' 1x, ' + img_120 + ' 2x"></a>';
      });
    } else {
      product_imgs.map( (img, i) => {
        pagingation_html += `<a href="#" class="gallery__pagination-item" data-image-index="${i}">Image</a>`;
      });
    }

    // unbind old thumbs if they exist
    $('.gallery__thumbnail-wrapper').off('click.rbProduct');
    // replace thumb html
    $('.gallery__thumbnails').html(thumb_html);
    $('.gallery__pagination').html(pagingation_html);


    if (SHTHelper.theme.product_photo_gallery) {
      gallery_height = $('#product-images').outerHeight();
      $('#product-images').css('height', gallery_height);

      SHTHelper.theme.product_photo_gallery.destroy();
      $('.reswiper-wrapper .reswiper-slide').remove();
      preloaded_img = $('<img/>');
      preloaded_img[0].src = _appendToFilename(product_imgs[0].url, '_1200x');
    }
    $('.reswiper-wrapper').prepend(imgs_html);
    if (preloaded_img) {
      preloaded_img.on('load', function() {
        $('#product-images').css('height', 'auto');
      });
    }

    SHTHelper.theme.product_photo_gallery = new Reswiper('.reswiper-container', {
      loop: false,
      effect: 'slide',
      speed: 250,
      navigation: {
        nextEl: '.reswiper-container .reswiper-button-next',
        prevEl: '.reswiper-container .reswiper-button-prev'
      },
      pagination: {
        el: '.reswiper-container .reswiper-pagination',
        type: 'bullets'
      },
      on: {
        slideChange: function() {
          // NOTE: runs even if no thumbnails exist, but thats fine
          setActiveThumbnail($('.gallery__thumbnail-wrapper[data-image-index="' + SHTHelper.theme.product_photo_gallery.activeIndex + '"]'));
          setActivePagination($('.gallery__pagination-item[data-image-index="' + SHTHelper.theme.product_photo_gallery.activeIndex + '"]'));
        }
      }
    });


    if (include_thumbnails) {

      // set inital slide to active
      setActiveThumbnail($('.gallery__thumbnail-wrapper[data-image-index="0"]'));

      $('.gallery__thumbnail-wrapper').on('click.rbProduct', function(e) {
        var target = $(e.target),
          img_indx;

        e.preventDefault();

        if (target.hasClass('gallery__thumbnail')) {
          target = target.parent('.gallery__thumbnail-wrapper');
        }
        target.addClass('gallery__thumbnail-wrapper--active').siblings().removeClass('gallery__thumbnail-wrapper--active');
        setActiveThumbnail(target);
        img_indx = target.data('image-index');
        SHTHelper.theme.product_photo_gallery.slideTo(img_indx);
      });
      $('.reswiper-button-next, .reswiper-button-prev, .gallery__thumbnails').removeClass('hidden');

    } else {
      //$('.reswiper-button-next, .reswiper-button-prev, .gallery__thumbnails').addClass('hidden');
      setActivePagination($('.gallery__pagination-item[data-image-index="0"]'));

      $('.gallery__pagination').on('click', '.gallery__pagination-item', e => {
        e.preventDefault();
        var target = $(e.target);
        var img_index = e.target.dataset.imageIndex;
        var pagination = target.parent('.gallery__pagination');
        target.addClass('gallery__pagination-item--active').siblings().removeClass('gallery__pagination-item--active');
        setActiveThumbnail(pagination);
        SHTHelper.theme.product_photo_gallery.slideTo(img_index);
      });
    }

  };
    // Image Galleries
    if ($('.reswiper-container').length && PRODUCT_IMAGES && PRODUCT_IMAGES.length) {

      $('.reswiper-container').append('<div class="reswiper-pagination reswiper-pagination-black"></div>  <div class="gallery__navigation"><button class="reswiper-button-prev reswiper-button-white gallery_nav_btn gallery_nav_prev"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none"><path d="M12.9983 1.59668L1.85547 12.0841L12.9983 22.5715" stroke="CurrentColor" stroke-width="1.85791" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button class="reswiper-button-next reswiper-button-white gallery_nav_btn gallery_nav_next"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none"><path d="M0.997773 22.1885L12.1406 11.7011L0.99778 1.2137" stroke="CurrentColor" stroke-width="1.85791" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>');

      if (PRODUCT_IMAGES.length < PRODUCT_IMG_THRESHOLD) {
        SHTHelper._buildProductPhotoGallery();
      } else {
        // NOTE: do nothing - variant selection will generate it
      }
    }

 document.addEventListener('variantChanged', (event) => {
    const eventData = event.detail;
    if (PRODUCT_IMAGES && PRODUCT_IMAGES.length >= PRODUCT_IMG_THRESHOLD) {
      SHTHelper._buildProductPhotoGallery(eventData.variant.sku, false);
    }
    if (PRODUCT_IMAGES.length && PRODUCT_IMAGES.length < PRODUCT_IMG_THRESHOLD && SHTHelper.theme.product_photo_gallery) {
      var found_indx = PRODUCT_IMAGES.findIndex(function(img) {
        // NOTE: ensuring string comparison
        return img.variant_id + '' === eventData.variant.id + '';
      });
      if (found_indx > -1) {
        SHTHelper.theme.product_photo_gallery.slideTo(found_indx);
      }
    }
  });

})(jQuery);

/* Color Dropdown */
// $(".acc_color").on("click", function(){
//     $(this).parent().siblings().slideToggle("slow");
//     $(this).toggleClass("open");
// });
$(window).on("load", function () {
  if($(window).width() < 769){
    var all = $('sht-prd-variant-swtch .product-swatches__item').length,
      visible = $('sht-prd-variant-swtch .product-swatches__item:visible').length;
  
    if(all - visible > 0) {
        $('sht-prd-variant-swtch').append( '<span class="more_color_view"> +'+(all - visible) + ' More</span>');
    }
    $(".more_color_view").on("click", function(){
       $(this).parent().toggleClass("view");
        $('sht-prd-variant-swtch .product-swatches__item:nth-child(n+6)').toggle();
       if($(this).is(":contains('More')")){ $(this).text("Less Color");}
        else{
            $(this).text('+'+(all - visible) + ' More');
        }
    });
  } else{
    $('sht-prd-variant-swtch .product-swatches__item:nth-child(n+6)').show();
    $(".more_color_view").hide();  
  }
});
$(window).on("resize", function () {
  
  if($(window).width() < 769){     
    if($("sht-prd-variant-swtch").children(".more_color_view").length < 1){
      var all = $('sht-prd-variant-swtch .product-swatches__item').length,
        visible = $('sht-prd-variant-swtch .product-swatches__item:visible').length;
    
      if(all - visible > 0) {
          $('sht-prd-variant-swtch').append( '<span class="more_color_view"> +'+(all - visible) + ' More</span>');
      }
      $(".more_color_view").on("click", function(){
         $(this).parent().toggleClass("view");
          $('sht-prd-variant-swtch .product-swatches__item:nth-child(n+6)').toggle();
         if($(this).is(":contains('More')")){ $(this).text("Less Color");}
          else{
              $(this).text('+'+(all - visible) + ' More');
          }
      });
    }
  } else{
    $('sht-prd-variant-swtch .product-swatches__item:nth-child(n+6)').show();
    $(".more_color_view").remove();  
  }
  
});

$(window).bind("load", function () {
   var scroll = $(window).scrollTop();
     let addtocart = $('.product__info__purchasing').offset().top + $('.product__info__purchasing').outerHeight();
     let prcdetail = $('.product__info__purchasing').offset().top;
     let viewportBottom = scroll + $(window).height();
      if (prcdetail > viewportBottom ) {
        $(".product__sticky-info").addClass("fix_btm_bar");
        //$("#chat-button").addClass("showchat");
      }
      else {
        $(".product__sticky-info").removeClass("fix_btm_bar");      
      }
})
  $(window).scroll(function () {
  var scroll = $(window).scrollTop();
     let addtocart = $('.product__info__purchasing').offset().top + $('.product__info__purchasing').outerHeight();
     let prcdetail = $('.product__info__purchasing').offset().top;
     let viewportBottom = scroll + $(window).height();
      if (prcdetail > viewportBottom ) {
        $(".product__sticky-info").addClass("fix_btm_bar");
        //$("#chat-button").addClass("showchat");
      }
      else {
        $(".product__sticky-info").removeClass("fix_btm_bar");      
      }
   });
  
  